// extracted by mini-css-extract-plugin
export default {"archive":"prevRP_archive__Eruq3","archiveBlock":"prevRP_archiveBlock__QwKn1"};